/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IndexNowTriggersQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type IndexNowTriggersQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly indexNowCustomElementTriggers: ReadonlyArray<string>, readonly indexNowNativeTriggers: ReadonlyArray<string> } | null };


export const IndexNowTriggersDocument = gql`
    query IndexNowTriggers($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    id
    indexNowCustomElementTriggers
    indexNowNativeTriggers
  }
}
    `;

/**
 * __useIndexNowTriggersQuery__
 *
 * To run a query within a React component, call `useIndexNowTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndexNowTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexNowTriggersQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useIndexNowTriggersQuery(baseOptions: Apollo.QueryHookOptions<IndexNowTriggersQuery, IndexNowTriggersQueryVariables> & ({ variables: IndexNowTriggersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndexNowTriggersQuery, IndexNowTriggersQueryVariables>(IndexNowTriggersDocument, options);
      }
export function useIndexNowTriggersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndexNowTriggersQuery, IndexNowTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndexNowTriggersQuery, IndexNowTriggersQueryVariables>(IndexNowTriggersDocument, options);
        }
export function useIndexNowTriggersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndexNowTriggersQuery, IndexNowTriggersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndexNowTriggersQuery, IndexNowTriggersQueryVariables>(IndexNowTriggersDocument, options);
        }
export type IndexNowTriggersQueryHookResult = ReturnType<typeof useIndexNowTriggersQuery>;
export type IndexNowTriggersLazyQueryHookResult = ReturnType<typeof useIndexNowTriggersLazyQuery>;
export type IndexNowTriggersSuspenseQueryHookResult = ReturnType<typeof useIndexNowTriggersSuspenseQuery>;
export type IndexNowTriggersQueryResult = Apollo.QueryResult<IndexNowTriggersQuery, IndexNowTriggersQueryVariables>;